module.exports = __webpack_public_path__ + "img/item1.208fe331.png";